import { AD_INVESTIGATOR_API, DELETE, FUBO_USER, GET, PUT, USER_PROFILE, VIDEO_AD_TYPE, VIEWER_ID } from '../constants';
import { jwtTokenHeader, request } from '../utils';
import { notification } from 'antd';
import { Buffer } from 'buffer';

export const createUpdateOverrides = async (overrideByInfo) => {
  return request(
    PUT,
    determinePathByAdTypeAndOverrideBy(AD_INVESTIGATOR_API, overrideByInfo),
    overrideByInfo.rules,
    await jwtTokenHeader(),
    'Failed creating or updating Override Rule.'
  );
};

let validateStatus = (status) => {
  let acceptedStatuses = ['200', '404'];
  return acceptedStatuses.includes(status.toString());
};

export const getOverrides = async (overrideByInfo, adType = VIDEO_AD_TYPE) => {
  const path = determinePathByAdTypeAndOverrideBy(AD_INVESTIGATOR_API, { adType: adType, ...overrideByInfo });
  const appQuery = buildAppQuery(overrideByInfo?.app);
  return request(
    GET,
    `${path}${appQuery}`,
    '',
    { ...(await jwtTokenHeader()), ...{ validateStatus: validateStatus } },
    'Failed fetching Override Rules.',
    false,
    (err) => {
      if (err?.response?.status === 404 || err?.response?.status === 504) {
        return {};
      } else {
        notification.error({
          message: 'Error getting Overrides',
          description: err.message,
          duration: 5,
        });
        throw err;
      }
    }
  );
};

export const removeOverrides = async (overrideByInfo) => {
  const path = determinePathByAdTypeAndOverrideBy(AD_INVESTIGATOR_API, overrideByInfo);
  const appQuery = buildAppQuery(overrideByInfo?.app);
  return request(DELETE, `${path}${appQuery}`, {}, await jwtTokenHeader(), 'Failed deleting Override Rule.');
};

export const buildAppQuery = (app) => {
  if (typeof app !== 'string' || !app) {
    return '';
  }

  const params = new URLSearchParams();
  // Backend expects single app scope: /devices/<base64>?app=...
  params.append('app', app);
  const query = params.toString();
  return query ? `?${query}` : '';
};

const determinePathByAdTypeAndOverrideBy = (
  host,
  { adType, overrideBy, userId, profileId, deviceId, swid, fuboUserId, viewerId }
) => {
  if (!adType) adType = VIDEO_AD_TYPE; // backward compatible

  let path = '';
  switch (overrideBy) {
    case USER_PROFILE:
      if (adType === VIDEO_AD_TYPE) {
        path = userId && profileId ? `users/${userId}/profiles/${profileId}` : 'users';
      } else {
        path = userId && profileId ? `accounts/${userId}/profiles/${profileId}` : 'accounts';
      }
      break;
    case 'device':
      path = deviceId ? `devices/${Buffer.from(deviceId).toString('base64')}` : 'devices';
      break;
    case 'swid':
      path = swid ? `swid/${swid}` : 'swid';
      break;
    case FUBO_USER:
      path = fuboUserId ? `fuboUser/${fuboUserId}` : 'fuboUser';
      break;
    case VIEWER_ID:
      path = viewerId ? `viewers/${viewerId}` : 'viewers';
      break;
    default:
      throw new Error(`Unknown overrideBy type: ${overrideBy}`);
  }

  const adTypePath = adType === VIDEO_AD_TYPE ? 'in-stream/' : 'pause/';
  return `${host}/v1/ad-overrides/${adTypePath}${path}`;
};
